<script lang="ts">
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export type svgIconSize =
  | iconSize
  | "height-xxs"
  | "height-xs"
  | "height-sm"
  | "height-md"
  | "height-lg"
  | "height-xl"
  | "height-xxl"
  | "width-xxs"
  | "width-xs"
  | "width-sm"
  | "width-md"
  | "width-lg"
  | "width-xl"
  | "width-xxl";
</script>

<script setup lang="ts">
import { computed } from "vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";

export interface SVGWrapperIconProps {
  viewBox: string;
  className?: string;
  size: svgIconSize;

  background?: colorTag;
}

const props = withDefaults(defineProps<SVGWrapperIconProps>(), {
  className: "",
  background: "transparent",
  size: "md",
});

const backgroundClass = computed((): string => `bg-${props.background}`);
const sizeClass = computed((): string => `icon-${props.size}`);
const inlineSize = computed((): { width: string; height: string } => {
  const BASE_SIZE = 1.25;
  const sizeMap: Record<iconSize, string> = {
    xxs: `${BASE_SIZE * 0.3}rem`,
    xs: `${BASE_SIZE * 0.6}rem`,
    sm: `${BASE_SIZE * 0.75}rem`,
    md: `${BASE_SIZE * 1}rem`,
    lg: `${BASE_SIZE * 1.2}rem`,
    xl: `${BASE_SIZE * 1.5}rem`,
    xxl: `${BASE_SIZE * 2}rem`,
  };

  if (props.size.includes("height")) {
    const stringSize = props.size.replace("height-", "") as iconSize;

    return { height: sizeMap[stringSize], width: "auto" };
  }

  if (props.size.includes("width")) {
    const stringSize = props.size.replace("width-", "") as iconSize;

    return { height: "auto", width: sizeMap[stringSize] };
  }

  return {
    width: sizeMap[props.size as iconSize],
    height: sizeMap[props.size as iconSize],
  };
});
</script>

<template>
  <svg
    :class="{
      [className]: className.length > 0,
      [backgroundClass]: background !== undefined,
      [sizeClass]: true,
    }"
    :viewBox="viewBox"
    :style="inlineSize"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <slot />
  </svg>
</template>
